import { FC, useEffect, useState } from "react";
import { Gizmo, IGizmo } from "flowy-3-core";
import * as S from "./Custom.styles";

type CustomProps = {
  gizmo: Gizmo;
};

const Custom: FC<CustomProps> = ({ gizmo }) => {
  const config: IGizmo = gizmo.getConfig();
  const customComponent = config.ops?.custom?.component;
  const [customGizmo, setCustomGizmo] = useState<any | undefined>();

  useEffect(() => {
    if (customComponent && typeof customComponent === "function") {
      const AnotherComponent = customComponent;
      setCustomGizmo(<AnotherComponent gizmo={gizmo} />);
    } else if (customComponent && typeof customComponent === "string") {
      import(`../../../../client/custom/${customComponent}`)
        .then((module) => {
          const AnotherComponent = module.default;
          setCustomGizmo(<AnotherComponent gizmo={gizmo} />);
        })
        .catch(() => {
          setCustomGizmo(null);
        });
    }
  }, [customComponent, gizmo]);

  return (
    <S.Custom
      id={`custom-${gizmo.getConfig().fid}`}
      columns={gizmo.getColumns()}
    >
      {customGizmo !== undefined && !null && customGizmo}
      {customGizmo === null && (
        <h4>Gizmo custom "{config.ops?.custom?.component}" No Existe</h4>
      )}
    </S.Custom>
  );
};

export default Custom;
